// Import react elements
import { useContext, useState } from "react";

// Import strich api calls
import { removeAccountReferral } from "api/APIStrichCalls";

// Import context functions
import { AuthContext } from "global/context/AuthContext";
import { UserContext } from "global/context/UserContext";

// Import components
import { GridItem } from "global/components/Grid";
import CreateButton from "global/components/CreateButton";
import HelpButton from "global/components/HelpButton";

// Import utility functions
import { DisplayConfirmationDialog } from "global/utilities/DialogBox";



const AffiliateReferral = ({ userData }) => {



    // Get the authentication token
    const { token } = useContext(AuthContext);

    // Get the user data setter so the account page can update immediately
    const { setUserData } = useContext(UserContext);

    // Track whether the referral is currently being removed
    const [removingReferral, setRemovingReferral] = useState(false);

    // Get the stored referral
    const referral = userData?.referral;

    // Do not display this section for accounts which were never referred
    if (!referral) { return null; }

    // Get the best public name available for the referrer
    const referrerName = referral.display_name || referral.affiliate_id;

    // Check whether this referral can currently earn commission
    const referralIsActive = referral.active === "Y";



    // Remove this account's active affiliate referral
    const handleRemoveReferral = () => {

        // Ask the user to confirm before disabling future affiliate earnings
        DisplayConfirmationDialog(

            "Are you sure you want to remove this affiliate referral?<br/><br/>The referrer will stop earning commission from future qualifying activity on your account. Commission already earned will not be affected.",

            "Remove Referral",

            "Cancel",

            // Handle the confirmation response
            async function (is_confirmed) {

                // Stop when the user cancelled
                if (!is_confirmed) { return; }

                // Show that the referral is being removed
                setRemovingReferral(true);

                try {

                    // Disable the referral
                    const response = await removeAccountReferral(token);

                    // Update the account data when the API succeeded
                    if (response?.success) {

                        setUserData((previousUserData) => ({
                            ...previousUserData,
                            referral: {
                                ...previousUserData.referral,
                                active: "N",
                            },
                        }));

                        return;

                    }

                    // Show the API error when the referral could not be removed
                    alert(response?.error || response?.error_message || "Oops...something went wrong.");

                } catch (error) {

                    // Log unexpected request failures
                    console.error("Remove affiliate referral error:", error);

                    alert("Oops...something went wrong.");

                } finally {

                    // Clear the loading state
                    setRemovingReferral(false);

                }

            }

        );

    };



    return (

        <GridItem>

            <h3>Affiliate Referral <HelpButton section="account" code="affiliate-referral" label="Affiliate Referral" /></h3>

            <br />

            <p>
                This account was referred by <strong>{referrerName}</strong>.
            </p>

            <p>
                Affiliate ID: <strong>{referral.affiliate_id}</strong>
            </p>

            <br />

            {referralIsActive ?

                <>

                    <p>
                        This affiliate may earn commission on qualifying sales you make through Strich and on subscription fees you pay.
                        This does not increase your costs or reduce your earnings.
                    </p>

                    <br />

                    <CreateButton
                        title={removingReferral ? "Removing..." : "Remove Referral"}
                        size="s"
                        invert={true}
                        onClick={handleRemoveReferral}
                        disabled={removingReferral}
                    />

                </>

            :

                <p>
                    This referral is inactive. The referrer no longer earns commission from future activity on your account.
                </p>

            }

        </GridItem>

    );

};



export default AffiliateReferral;